import React, { useState, useRef, useEffect } from 'react';


const getIconPath = (config) => {
  return `/icons/${config.character}_${config.costume_id}.webp`;
};


const Item = ({ config, defaultName }) => {

  if (config == null){
    return (
      <div className="flex items-center z-10 w-20 px-2 py-2">
        {defaultName}
      </div>
    );
  } else {

  return (
    <div className="flex items-center z-10 w-full px-2 py-2">
      <img
        src={getIconPath(config)}
        alt=""
        className="w-5 h-5 rounded-full mr-2 z-10"
      />
      <span className="text-gray-300 z-10 w-20 truncate">{config.tag}</span>
      <span className="text-gray-300 z-10 flex ml-2">({config.elo.toFixed(0)})</span>
    </div>
  );
  }

};

const LiveBots = ({ liveBots, onSelect, selected, defaultName }) => {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOnOption = (index) => {
    setIsOpen(!isOpen)

    return onSelect(index);
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block block" ref={dropdownRef}>
      <button
        type="button"
        className="inline-flex items-center border border-pink-300/30 bg-pink-400/20 rounded-lg hover:border-pink-300 py-1 duration-200 ease-in-out"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Item config={liveBots[selected]} defaultName={defaultName} />
        <svg
          className="-mr-1 mr-1 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="white"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      {isOpen && (
        <div
          className="z-20 absolute right-0 mt-2 rounded-md bg-gray-950/95 border border-pink-300/30"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div className="py-1 z-10">
            {liveBots.map((config, index) => (
              <button
                onClick={() => handleClickOnOption(index)}
                className='hover:bg-pink-400/30 w-full pr-4 duration-200 ease-in-out'
                key={index}
              >
                <Item config={config}/>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default LiveBots;